import {
  Directive, Input, ElementRef, AfterViewInit, ChangeDetectorRef,
} from '@angular/core';


@Directive({
  selector: '[cellWidth]',
  exportAs: 'cell-width',
})
export class CellWidthDirective implements AfterViewInit {
  @Input() column: any;
  @Input() row: any;
  @Input() minWidth: number = 40;
  @Input() cellOffset: number = 20;
  @Input() isHeaderColumn: boolean = false;

  get width(): number {
    return this.elementRef.nativeElement.offsetWidth;
  }

  constructor(
    public elementRef: ElementRef,
    private ref: ChangeDetectorRef,
  ) {}

  ngAfterViewInit() {
    this.updateMaxWidth();
  }

  public updateMaxWidth() {
    // set default width for all cells
    if (!this.column.maxWidth) {
      this.column.maxWidth = this.minWidth + this.cellOffset;
    }
    if ((this.width + this.cellOffset) >= this.column.maxWidth) {
      this.column.maxWidth = this.width + this.cellOffset;
    }
    // check if column header width from sorting panel is longer that cell value
    if (this.column.headerColumnWidth && this.column.headerColumnWidth > this.column.maxWidth) {
      this.column.maxWidth = this.column.headerColumnWidth;
    }
    // save column header width from sorting panel
    if (this.isHeaderColumn) {
      this.column.headerColumnWidth = this.column.maxWidth;
    }
    this.ref.markForCheck();
  }
}
